import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { MediaQuery } from '@alphorm/ui'
import DesktopLearningPath from 'components/LearningPath/DesktopLearningPath'
import ResponsiveLearningPath from 'components/LearningPath/ResponsiveLearningPath'
import Seo from './Seo'

export default ({ fetchLearningPath, loading, resetLearningPath }) => {
  const { slug } = useParams()

  useEffect(() => {
    resetLearningPath()
    if (slug) {
      fetchLearningPath(slug)
    }
  }, [slug])

  return (
    <>
      {loading ? null : <Seo />}
      <MediaQuery ShowOnDesktop>
        <DesktopLearningPath />
      </MediaQuery>
      <MediaQuery HideOnDesktop>
        <ResponsiveLearningPath />
      </MediaQuery>
    </>
  )
}
